module.exports = __webpack_public_path__ + "static/img/introduceBTypeBIcon1.57d1b11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introduceBTypeBIcon1.png
// module id = wLNv
// module chunks = 0